import auth from "@/auth";import { useUserStore } from "@/stores/userStore";
import axios from "axios";
import { createPinia } from "pinia";
import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import router from "./router";
import { useErrorHandlingStore } from "./stores/errorHandling";

loadFonts();
const app = createApp(App).use(router).use(vuetify).use(createPinia());

const userStore = useUserStore();
const errorHandlingStore = useErrorHandlingStore();

//This method I need
async function authenticateUser() {
  await auth.setToken();
  if (!userStore.isAuthenticated) {
    await auth.login();
  } else {
    addInterceptor();
    app.mount("#app");
  }
}

authenticateUser().then(() => {
  console.log("Login Success");
});

const addInterceptor = () => {
  axios.interceptors.request.use(async (config) => {
    const user = await auth.getUser();
    config.headers.Authorization = `Bearer ${user.id_token}`;
    config.headers["gcms-groups"] = user?.profile.groups;
    config.headers["ha-user-id"] = user?.profile.HAUserID;
    config.headers["gcms-user-id"] = user?.profile.sub;
    config.headers["gcms-bp-id"] = user?.profile.HAFirmID;
    config.headers["gcms-district"] = user?.profile.WorkUnitCode?.slice(0, 2);
    config.headers["gcms-email"] = user?.profile.email;
    config.headers["gcms-last-name"] = user?.profile.family_name;
    config.headers["gcms-first-name"] = user?.profile.given_name;
    config.headers["gcms-domino-full-name"] = user?.profile.DominoFullName;
    return config;
  });
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response.status != 409) {
        errorHandlingStore.setErrorHandling(
          true,
          error?.response?.data?.message ||
            error?.response?.data?.businessMessage ||
            error?.response?.data?.title ||
            "Something went wrong."
        );
      }
      return Promise.reject(new Error(error));
    }
  );
};
